export const serviceData = [
  {
    text: 'PR TIMESとは',
    href: '/service',
  },
  {
    text: '料金・プラン',
    href: '/price',
  },
  {
    text: 'プレスリリースを受信したい方へ',
    href: '/user_info',
  },
  {
    text: 'プレスリリースを配信したい方へ',
    href: '/main/registcorp/form',
  },
];
